import { cashBalances } from '../cashBalance'
import { describeTable } from './describeTable'

describeTable(cashBalances, {
  description: `Observed closing balance of a cash account on a day, one row per account per day. The daily cash forecast opens from the latest row on or before its start and runs cash_events forward from the next day. Written only by the nightly Fennoa ledger import — there is no manual entry; a bank feed would write the same rows.`,
  columns: {
    date: 'The day whose closing balance this is.',
    balance: 'Closing balance at the end of that day.',
    source:
      'fennoa:ledger = booked balance read from the ledger account, dated by the last booked statement day; bank = from a bank statement (not yet used).',
  },
})
